import { render, staticRenderFns } from "./InviteJoin2.vue?vue&type=template&id=aaba142a&scoped=true"
import script from "./InviteJoin2.vue?vue&type=script&lang=js"
export * from "./InviteJoin2.vue?vue&type=script&lang=js"
import style0 from "./InviteJoin2.vue?vue&type=style&index=0&id=aaba142a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaba142a",
  null
  
)

export default component.exports